import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { ArrowBack } from '@bibliocommons/base-icons';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import Heading from '@bibliocommons/heading';

import { ROUTE } from 'app/constants/AdminBrowseConstants';
import { browseHomePageShape } from 'app/shapes/browse';

const AdminBrowseHomeEditPage = ({ browseHomePage, currentUser, hasSuccessNotice, onSave }) => {
  const [browseHomePageCopy, setBrowseHomePageCopy] = useState({ ...browseHomePage });

  const handleSubmit = event => {
    event.preventDefault();

    onSave({ ...browseHomePageCopy, updatedAt: Date.now(), updatedBy: currentUser.get('name') });
  };

  const handleNameChange = event => {
    const newName = event.target.value;

    setBrowseHomePageCopy(prevBrowseHomePageCopy => {
      return {
        ...prevBrowseHomePageCopy,
        name: newName
      };
    });
  };

  const { browseHomePageId, name } = browseHomePageCopy;
  return (
    <div className="cp-admin-browse-home-edit-page container">
      <Link
        dataKey="back-to-browse-home"
        to={ROUTE.ADMIN_BROWSE_HOME}
        style={{ color: 'var(--generic-darkgrey)', fontWeight: 600, textDecoration: 'none' }}
      >
        <span style={{ marginRight: '6px' }}>
          <ArrowBack />
        </span>
        <span>Back to Browse Home</span>
      </Link>

      {hasSuccessNotice && <p style={{ background: 'green', color: 'white', padding: '10px' }}>Saved!</p>}

      <Heading size="large" tagName="h1" variant>
        Browse Home Edit
      </Heading>

      <p>Browse Home Page ID: {browseHomePageId}</p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="BrowsePageName">Name</label>
        <br />
        <input
          id="BrowsePageName"
          name="BrowsePageName"
          onChange={handleNameChange}
          placeholder="Name"
          required
          type="text"
          value={name}
        />
        <br />
        <br />
        <button type="submit">Save</button>
      </form>
    </div>
  );
};

AdminBrowseHomeEditPage.propTypes = {
  browseHomePage: browseHomePageShape.isRequired,
  currentUser: userIdentityShape.isRequired,
  hasSuccessNotice: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired
};

export default AdminBrowseHomeEditPage;
